module.exports = __webpack_public_path__ + "img/top-image1.cfc17675.png";